import { render, staticRenderFns } from "./ViewEditDialog.vue?vue&type=template&id=40cfce9b&scoped=true"
import script from "./ViewEditDialog.vue?vue&type=script&lang=ts"
export * from "./ViewEditDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40cfce9b",
  null
  
)

export default component.exports